import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import styled from "styled-components";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import "./CommissionCreationForm.css";
import DatePicker from "react-datepicker";
import Modal from "react-responsive-modal";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import CommissionCreationCorrectiveEvent from "./CommissionCreationCorrectiveEvent";

import { create_commission,commissionUpdate } from "../redux/actions";

import { HeaderDivider } from "../../common/components/HeaderDivider";
import { Button } from "../../common/components/Button";
import { CommissionHeaders } from "../../common/components/SectionHeader";
import { ErrorMessage } from "../../common/components/ErrorMessage";
import { FaTimes } from "react-icons/fa";
import "../../components/Purchases/Disclosure.css";
import Disclosure from "../../components/Purchases/Disclosure";
import DisclosureModal from "./DisclosureModal";
import { ConvertTimeZoneValue } from "../../util";
import 'bootstrap/dist/css/bootstrap.min.css';


const FormButton = styled(Button)`
	height: 25px;
`;

const ButtonHolder = styled.div`
	margin-top: 10px;
`;

const RightSideButton = styled(Button)`
	marginright: 15px;
`;

const LeftSideButton = styled(Button)`
	float: right;
`;

class CommissionCreationForm extends Component {
	constructor() {
	super();
	this.state = {
		commission_name: "",
		ticker: "",
		notes: "",
		class_start_period: null,
		class_end_period: null,
		corrective_events: [
		{
			date: "",
			percentage: "100"
		},
		],
		openModal: false,
		isUpdateForm: false,
		loader:false
	 
	};
	}

	componentDidMount() {
	let caseId = this.props.match.params.caseId;
	if (caseId) {
		if(caseId!=='0'){
		this.setState({ isUpdateForm: true });
		this.props.commissionUpdate(caseId)
		}
	}  
	
	
	}

	componentWillReceiveProps(nextProps) {
	
	if (nextProps && nextProps.UpdateCommissionResult) {
	 
		var startDate = new Date(nextProps.UpdateCommissionResult.startDate)
		var endDate = new Date(nextProps.UpdateCommissionResult.endDate)
		

		this.setState({ 
			commission_name: nextProps.UpdateCommissionResult.fillingName,
			ticker:nextProps.UpdateCommissionResult.ticker,
			notes:nextProps.UpdateCommissionResult.notes,
			class_start_period: startDate,
			class_end_period: endDate,       
		});
	
	if(nextProps.UpdateCommissionResult.correctiveEvents!=null){
		let updated_times=[]
	
		for(let i = 0;i < nextProps.UpdateCommissionResult.correctiveEvents.length; i++){
		updated_times = this.state.corrective_events.concat({
			date: "",
			percentage: "100"
		})      
		}
		 
	// setTimeout(() => {     
		nextProps.UpdateCommissionResult.correctiveEvents.map((res,index)=>{
			var date = new Date(res.disclosureDate)
			updated_times[index]["date"] = date;
			updated_times[index]["percentage"] = res.percentage;
			this.setState({ corrective_events: updated_times });
			return res
		})
	// },1000);
	}
	
	 this.setState({loader:global.loader})
	 
	 }
	}

	change_commission_name = event => {
	this.setState({ commission_name: event.target.value });
	};

	change_notes = event => {
	this.setState({ notes: event.target.value });
	};

	change_ticker = event => {
	this.setState({ ticker: event.target.value });
	};

	change_start_period = date => {
	this.setState({ class_start_period: date });
	};

	change_end_period = date => {
	this.setState({ class_end_period: date });
	};

	add_corrective_event = () => {
	this.setState({
		corrective_events: this.state.corrective_events.concat({
		date: "",
		percentage: "100"
		})
	});
	};

	remove_corrective_event = index => {
	let events = [...this.state.corrective_events];
	events.splice(index, 1);
	this.setState({ corrective_events: events });
	};

	change_corrective_event = (index, date) => {
	let updated_times = this.state.corrective_events;
	updated_times[index]["date"] = date;

	this.setState({ corrective_events: updated_times });
	};
	
	onChangepercentage = (index, e) => {
	if (e.target.validity.valid) {
	if(e.target.value.length<4){
		if(e.target.value==='000' ){
		return (e.target.value = 0);
		}
		if ( e.target.value > 100) {
		return (e.target.value = 0);
		}
		let updated_times = this.state.corrective_events;
		updated_times[index]["percentage"] = e.target.value;
		this.setState({ corrective_events: updated_times });
	}
	}
	};

	incrementdecrementValue = (index, data, type) => {
	data = parseInt(data ? data : 0, 10);
	if (data >= 0 && data <= (type === "plus" ? 99 : 100)) {
		let updated_times = this.state.corrective_events;
		updated_times[index]["percentage"] =
		type === "plus" ? data + 1 : data === 0 ? 0 : data - 1;
		this.setState({ corrective_events: updated_times });
	}
	};

	submit_form = () => {
	 this.setState({loader:true})

	this.state.corrective_events.map(
		res => (res.date = ConvertTimeZoneValue(res.date))
	);
	const data = {
		symbol: this.state.ticker,
		commissionName: this.state.commission_name,
		periodStartDate: ConvertTimeZoneValue(this.state.class_start_period),
		periodEndDate: ConvertTimeZoneValue(this.state.class_end_period),
		notes: this.state.notes,
		correctiveEvents: this.state.corrective_events.filter(x => !!x)
	};

	this.props.create_commission(data,this.props.firmSettings.subscription);
	};

	onCloseModal = () => {
	this.setState({ openModal: false });
	};

	onOpenModel = () => {
	this.setState({ openModal: true });
	};

	getProperDate = data => {
	if (data) {
		var date = new Date(data);
		var year = date.getFullYear();
		var month = (1 + date.getMonth()).toString().padStart(2, "0");
		var day = date
		.getDate()
		.toString()
		.padStart(2, "0");
		return month + "/" + day + "/" + year;
	} else {
		return "";
	}
	};

	render() {
	let errorMessage = null;
	if (this.props.new_commission_error) {
		errorMessage = (
		<ErrorMessage>{this.props.new_commission_error}</ErrorMessage>
		);
	}

	let corrective_events =
		this.state.corrective_events.length === 0
		? [
			<CommissionCreationCorrectiveEvent
				key={0}
				data={this.state.corrective_events[0]}
				maxDate={moment()}
				onChange={(date, type) =>
				this.change_corrective_event(0, date, type)
				}
				onChangepercentage={data => this.onChangepercentage(0, data)}
				incrementdecrementValue={(data, type) =>
				this.incrementdecrementValue(0, data, type)
				}
				isClearable={true}
				dropdownMode={"select"}
				className={"commission-input"}
				remove_corrective_event={this.remove_corrective_event}
				add_corrective_event={this.add_corrective_event}
				cur_length={1}
				index={0}
			/>
			]
		: this.state.corrective_events.map((t, index) => {
			return (
				<CommissionCreationCorrectiveEvent
				key={index}
				data={this.state.corrective_events[index]}
				maxDate={moment()}
				onChange={(date, type) =>
					this.change_corrective_event(index, date, type)
				}
				onChangepercentage={data =>
					this.onChangepercentage(index, data)
				}
				incrementdecrementValue={(data, type) =>
					this.incrementdecrementValue(index, data, type)
				}
				isClearable={true}
				dropdownMode={"select"}
				className={"commission-input"}
				remove_corrective_event={this.remove_corrective_event}
				add_corrective_event={this.add_corrective_event}
				cur_length={this.state.corrective_events.length}
				index={index}
				/>
			);
			});
			const commission_disabled = this.state.commission_name === "" ||
			!!!this.state.ticker ||
			!!!this.state.class_start_period ||
			!!!this.state.class_end_period ||
			!this.state.corrective_events.map(x => {
			return (x.date!=="")&&(x.date!==null)
			 }).includes(false)!==true


	return (
		<React.Fragment>
		<div>
			<div>{errorMessage}</div>     
			<CommissionHeaders>
			Commission Custom Severity Report
			</CommissionHeaders>
			<HeaderDivider />
			<div className="fullwidth" id={"commission-report-basic-data"}>
			<div className="name-width">
				<div className={"commission-input-label"}>
				Custom Severity Report Name
				</div>
				<input
				value={this.state.commission_name}
				readOnly={this.state.isUpdateForm}
				className={"commission-input fullwidth"}
				onChange={this.change_commission_name}
				placeholder={"Custom Severity Report Name"}
				/>
			</div>
			<div className="ticker-width">
				<div className={"commission-input-label"}>Ticker</div>
				<input
				value={this.state.ticker}
				readOnly={this.state.isUpdateForm}
				className={"commission-input fullwidth"}
				onChange={this.change_ticker}
				placeholder={"Ticker"}
				/>
			</div>
			<div className="startdt-width">
				<div className={"commission-input-label"}>Class Period Start Date</div>
				<DatePicker
				selected={this.state.class_start_period}
				onChange={date => this.change_start_period(date)}
				placeholderText={"Select date"}
				maxDate={moment()}
				dropdownMode={"select"}
				className={"commission-input fullwidth"}
				showYearDropdown
				readOnly={this.state.isUpdateForm}
				/>
			</div>
			<div className="enddt-width">
				<div className={"commission-input-label"}>Class Period End Date</div>
				<DatePicker
				readOnly={this.state.isUpdateForm}
				selected={this.state.class_end_period}
				onChange={date => this.change_end_period(date)}
				placeholderText={"Select date"}
				maxDate={moment()}
				dropdownMode={"select"}
				className={"commission-input fullwidth"}
				showYearDropdown
				/>
			</div>
			</div>
		</div>
		<div id={"corrective-events-holder"}>
			<CommissionHeaders>Alleged Corrective Events</CommissionHeaders>
			<HeaderDivider />
			
			{corrective_events}
			<div className="m-t-20">
			<div className={"commission-input-label"}>Notes</div>
			<textarea
				className={"commission-input"}
				onChange={this.change_notes}
				cols={40}
				rows={3}
				placeholder={"Notes"}
				value={this.state.notes}
			/>
			</div>
		</div>

		<div id={"commission-button-holder"}>
			<FormButton
			height={"25px"}
			disabled={commission_disabled}
			onClick={this.onOpenModel}
			tabIndex="-1"
			>
			Commission
			</FormButton>
			<Link to={this.state.isUpdateForm?"/cases/"+this.props.match.params.caseId:"/commissions"}>
			<FormButton>Cancel</FormButton>
			</Link>
		</div>

		{/* //  Privileged and Confidential model start */}
		<Modal
			open={this.state.openModal}
			onClose={this.onCloseModal}
			focusTrapped={true}
			styles={{ modal: { height: "90%", overflow: "auto" } }}
		>
			<div className="ModalWindow modaladd">
			<FaTimes className="closeicon" onClick={this.onCloseModal} />
			<div className="modalHeading"></div>
			<div className="NavDivider"></div>
			<Disclosure />
			<div className="NavDivider"></div>
			<div>
				<DisclosureModal createFormState={this.state} />
			</div>
			<div>
				<div className="NavDivider"></div>
				<ButtonHolder>
				<RightSideButton
					onClick={() => this.submit_form()}
					hoverBorderColor="darkgreen"
					tabIndex="-1"
				>
					Confirm Commission
				</RightSideButton>
				<LeftSideButton
					onClick={this.onCloseModal}
					hoverBorderColor="red"
					tabIndex="-1"
				>
					Decline
				</LeftSideButton>
				</ButtonHolder>
			</div>
			</div>
		</Modal>
		{/* //  Privileged and Confidential model end */}
		<Modal
			open={this.state.loader}
			onClose={this.onCloseModal}
			focusTrapped={true}
			styles={{ modal: { marginTop:(window.outerHeight/2)-80 } }}
		>       
		 <div className="loader"></div>
		</Modal>
		</React.Fragment>
	);
	}
}

const mapStateToProps = state => {

	return {
	commission_request: state.commissions.commission_request,
	new_commission_error: state.commissions.new_commission_error,

	firmSettings:state.firmSettings,
	UpdateCommissionResult: state.commissions.UpdateCommissionResult,
	};
};

const mapDispatchToProps = dispatch => {
	return {
	create_commission: (data,subscription) => dispatch(create_commission(data,subscription)),
	commissionUpdate: resultCommission => dispatch(commissionUpdate(resultCommission)),
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(withRouter(CommissionCreationForm));



// WEBPACK FOOTER //
// ./src/commissions/components/CommissionCreationForm.js